
import { Component, Vue } from 'nuxt-property-decorator';
import { ThemeName } from '~/store/types';
import VideoPlayer from '~/components/Player/VideoPlayer.vue';

@Component({
  components: {
    VideoPlayer,
  },
  meta: {
    theme: ThemeName.DARK,
  },
})
export default class Watch extends Vue {
  get slug() {
    return this.$route.params.slug || '';
  }

  get isMobile() {
    return this.$vuetify.breakpoint.xs;
  }

  created() {
    this.$store.commit('toggleHeader', false);
    this.$store.commit('toggleFooter', false);
  }

  destroyed() {
    this.$store.commit('toggleHeader', true);
    this.$store.commit('toggleFooter', true);
  }
}
